import { ModuleBase } from "@/modules/base";
import { Component, Mixins } from 'vue-property-decorator';
import AnalysisMenu from "./AnalysisMenu.vue";
import Window from './Window/index.vue'
import OverlayLayer from "./OverlayLayer.vue";

@Component
export class HipsModule extends Mixins(ModuleBase) {
  showWindow = false

  frameStore() {
    return {
      baseUrl: undefined as string | undefined,
    }
  }

  get outlet() {
    return {
      analysisMenu: AnalysisMenu,
      window: Window,
      overlayLayer: OverlayLayer,
    }
  }
}
